<template>
  <div class="home">
    <h2>Whitelabels</h2>

    <b-button @click="raisePopup({ target: $event.target })" variant="primary">
      Add new
    </b-button>

    <!-- Info modal -->
    <b-modal
      id="whitelabelsModal"
      v-bind:title="this.isEdit ? 'Edit whitelabel' : 'New whitelabel'"
      @ok="checkForm"
    >
      <b-form>
        <div v-if="errors.length">
          <b>Пожалуйста исправьте указанные ошибки:</b>
          <ul>
            <li v-for="error in errors">{{ error }}</li>
          </ul>
        </div>
        <input id="newWhitelabelInput0" type="hidden" v-model="form.id" />
        <b-form-group
          id="newWhitelabelInputGroup1"
          label="Name:"
          label-for="newWhitelabelInput1"
        >
          <b-form-input
            id="newWhitelabelInput1"
            type="text"
            v-model="form.name"
            required
            placeholder="Enter Name"
          />
        </b-form-group>

        <b-form-group
          id="newWhitelabelInputGroup2"
          label="FE URL"
          label-for="newWhitelabelInput2"
        >
          <b-form-input
            id="newWhitelabelInput2"
            type="text"
            v-model="form.feUrl"
            required
            placeholder="Enter FE URL"
          />
        </b-form-group>

        <b-form-group
          id="newWhitelabelInputGroup3"
          label="Deploy config:"
          label-for="newWhitelabelInput3"
        >
          <b-form-input
            id="newWhitelabelInput3"
            type="text"
            v-model="form.deployConfiguration"
            required
            placeholder="Enter Deploy Configuration in JSON"
          />
        </b-form-group>

        <!-- Картинка 1 -->
        <b-form-group
          id="newWlConfigInputGroup2"
          label="Image HD:"
          label-for="wlImageHD"
        >
          <b-form-file
            id="wlImageHD"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            v-model="form.imageHD"
            required
          ></b-form-file>
        </b-form-group>

        <!-- Картинка 2 -->
        <b-form-group
          id="newWlConfigInputGroup2"
          label="Image FullHD:"
          label-for="wlImageFHD"
        >
          <b-form-file
            id="wlImageFHD"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            v-model="form.imageFHD"
            required
          ></b-form-file>
        </b-form-group>

        <!-- CSS -->
        <b-form-group
          id="newWlConfigInputGroup2"
          label="CSS:"
          label-for="wlCss"
        >
          <b-form-file
            id="wlCss"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            v-model="form.cssConfig"
            required
          ></b-form-file>
        </b-form-group>

        <b-form-group
          id="newWhitelabelInputGroup4"
          label="Max version:"
          label-for="newWhitelabelInput4"
        >
          <Dropdown
            placeholder="Max app version allowed in SEMVER format XX.YY.ZZ"
            v-model="form.maxVersion"
            :list="$store.state.versions"
          />
        </b-form-group>
      </b-form>
    </b-modal>

    <b-container fluid>
      <!-- User Interface controls -->
      <!--<b-row>-->
      <!--<b-col md="12" class="my-1">-->
      <!--<b-form-group label-cols-sm="1" label="Filter" class="mb-0">-->
      <!--<b-input-group>-->
      <!--<b-form-input v-model="filter" placeholder="Type to Search" />-->
      <!--<b-input-group-append>-->
      <!--<b-button :disabled="!filter" @click="filter = ''"-->
      <!--&gt;Clear</b-button-->
      <!--&gt;-->
      <!--</b-input-group-append>-->
      <!--</b-input-group>-->
      <!--</b-form-group>-->
      <!--</b-col> </b-row>-->
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="2" label="Sort" class="mb-0">
            <b-input-group>
              <b-form-select v-model="sortBy" :options="sortOptions">
                <option slot="first" :value="null">-- none --</option>
              </b-form-select>
              <b-form-select
                :disabled="!sortBy"
                v-model="sortDesc"
                slot="append"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        small
        hover
        stacked="md"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @filtered="onFiltered"
        ref="whitelabelsTable"
        class="whitelabelsTable"
      >
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            class="m-1"
            @click="row.toggleDetails"
            variant="info"
          >
            …
          </b-button>
          <b-button
            size="sm"
            class="m-1"
            variant="warning"
            @click="
              raisePopup({
                target: $event.target,
                isEdit: true,
                whitelabel: row.item
              })
            "
          >
            ✎
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            @click="
              deleteWhitelabel({
                target: $event.target,
                whitelabel: row.item
              })
            "
          >
            X
          </b-button>
        </template>

        <template v-slot:cell(deployConfiguration)="row">
          <div v-b-popover.hover="`${row.value}`">
            {{ row.value.slice(0, 50) }}...
          </div>
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
              <li>
                ImageHD:
                <a
                  :href="
                    `https://${row.item.name}.webapp.lfstrm.tv/whitelabels/${row.item.name}/assets/loading_logo_1280x720.png`
                  "
                  target="_blank"
                  >Open new tab</a
                >
              </li>
              <li>
                ImageFHD:
                <a
                  :href="
                    `https://${row.item.name}.webapp.lfstrm.tv/whitelabels/${row.item.name}/assets/loading_logo_1920x1080.png`
                  "
                  target="_blank"
                  >Open new tab</a
                >
              </li>
              <li>
                ConfigCss:
                <a
                  :href="
                    `https://${row.item.name}.webapp.lfstrm.tv/whitelabels/${row.item.name}/styles/indexHtml.css`
                  "
                  target="_blank"
                  >Open new tab</a
                >
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>

      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */
import Dropdown from '../components/Dropdown';

const originalForm = {
  id: null,
  name: null,
  feUrl: null,
  imageHD: null,
  imageFHD: null,
  cssConfig: null,
  deployConfiguration: null,
  maxVersion: null
};

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100, 500],
      sortBy: null,
      sortDesc: false,
      filter: null,
      form: {
        ...originalForm
      },
      isEdit: false,
      errors: []
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    fields() {
      return [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'feUrl',
          label: 'FE URL',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'deployConfiguration',
          label: 'Deploy config',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'maxVersion',
          label: 'Max version allowed',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'createdAt',
          label: 'Created',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'updatedAt',
          label: 'Updated',
          sortable: true,
          class: 'text-center'
        },
        { key: 'actions', label: 'Actions' }
      ];
    },
    totalRows() {
      return this.$store.state.whitelabels.count;
    }
  },
  methods: {
    raisePopup({ target, isEdit = false, whitelabel = null }) {
      this.errors = [];
      this.isEdit = isEdit;
      if (whitelabel && isEdit) {
        this.form = Object.keys(originalForm).reduce(
          (acc, current) =>
            whitelabel[current]
              ? {
                  ...acc,
                  [current]: String(whitelabel[current])
                }
              : acc,
          {}
        );
      } else {
        this.whitelabelFormReset();
      }
      this.$root.$emit('bv::show::modal', 'whitelabelsModal', target);
    },
    async checkResources(url, message) {
      const result = await fetch(url);

      if (!result.ok) {
        this.errors.push(message);
      }
    },
    async checkForm(e) {
      e.preventDefault();

      const requiredFields = ['name', 'feUrl', 'deployConfiguration'];
      this.errors = [];
      const imageHD = '1280x720';
      const imageFHD = '1920x1080';
      if (this.isEdit && this?.form?.name) {
        if (!this?.form?.imageHD) {
          await this.checkResources(
            `https://${this.form.name}.webapp.lfstrm.tv/whitelabels/${this.form.name}/assets/loading_logo_${imageHD}.png`,
            `Требуется загрузить изображение ${imageHD}`
          );
        }

        if (!this?.form?.imageFHD) {
          await this.checkResources(
            `https://${this.form.name}.webapp.lfstrm.tv/whitelabels/${this.form.name}/assets/loading_logo_${imageFHD}.png`,
            `Требуется загрузить изображение ${imageFHD}`
          );
        }
        if (!this?.form?.cssConfig) {
          await this.checkResources(
            `https://${this.form.name}.webapp.lfstrm.tv/whitelabels/${this.form.name}/styles/indexHtml.css`,
            `Требуется загрузить CSS`
          );
        }
      } else {
        requiredFields.push('imageHD', 'imageFHD', 'cssConfig');
      }

      requiredFields.forEach(field => {
        if (!this?.form[field]) {
          this.errors.push(`Требуется указать ${field}`);
        }
      });

      if (this.errors.length === 0) {
        this.whitelabelFormSubmit(e);
      }
    },
    deleteWhitelabel({ whitelabel = null }) {
      if (!whitelabel) {
        return;
      }
      const promise = this.$store.dispatch('deleteWhitelabel', {
        id: whitelabel.id,
        name: whitelabel.name
      });

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        this.$refs.whitelabelsTable.refresh();
      });
    },
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.currentPage = 1;
    },
    items(ctx) {
      const promise = this.$store.dispatch('getWhitelabels', ctx);

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        // Pluck the array of items off our axios response
        const items = this.$store.state.whitelabels.rows.map(item => {
          if (item.deployConfiguration) {
            item.deployConfiguration = JSON.stringify(item.deployConfiguration);
          }
          return item;
        });
        // Must return an array of items or an empty array if an error occurred
        return items || [];
      });
    },
    whitelabelFormReset() {
      this.form = { ...originalForm };
    },
    whitelabelFormSubmit(event) {
      const formData = new FormData();
      Object.keys(originalForm).forEach(el =>
        formData.append(el, this.form[el])
      );

      this.$store.dispatch(this.isEdit ? 'editWhitelabel' : 'addWhitelabel', {
        formData,
        event
      });

      this.$nextTick(function() {
        this.$root.$emit('bv::hide::modal', 'whitelabelsModal', event.target);
      });
      this.whitelabelFormReset();
      this.$refs.whitelabelsTable.refresh();
    }
  },
  mounted() {
    this.$store.dispatch('getVersions');
  },
  components: { Dropdown }
};
</script>
<style scoped type="text/scss">
.block {
  border-bottom: #dadada 1px solid;
  padding-bottom: 1em;
  margin-bottom: 3em;
}
.container {
  max-width: none;
}
.whitelabelsTable {
  font-size: 0.8rem;
}
.btn {
  font-size: 0.8rem;
}

td[data-label='Actions'] {
  white-space: nowrap;
}
</style>
